<div *ngIf="!loading" class="form-group">
  <div>
    <mat-form-field class="example-full-width">
      <mat-label>{{ label ? label : plholder }}</mat-label>
      <input
        type="text"
        [(ngModel)]="clientSelected"
        [placeholder]="plholder"
        aria-label="Client Name or Company Name"
        matInput
        [formControl]="myControlClientes"
        [matAutocomplete]="autoClientes"
        id="clienteSP"
        required
      />

      <mat-autocomplete
        (optionSelected)="OnHumanSelected($event.option)"
        #autoClientes="matAutocomplete"
        [displayWith]="displayFn"
      >
        <mat-option *ngIf="type === 'customer'" [value]="nuevoCliente">
          <strong style="font-size: 20px">
            <i
              style="color: #28b463"
              class="fa fa-plus-circle"
              aria-hidden="true"
            ></i>
            &nbsp; {{ nuevoCliente.name }}
          </strong>
        </mat-option>

        <mat-option
          *ngFor="let option of filteredClientes | async"
          [value]="option"
        >
          {{ option.name }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>

  <button *ngIf="sync" class="btn btn-success" (click)="syncCompanies()">
    <i *ngIf="syncpos" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
    Sync Companies
  </button>
</div>

<mat-progress-bar
  class="my-4"
  style="width: 100%"
  *ngIf="loading"
  id="loadingbar"
  mode="indeterminate"
>
</mat-progress-bar>
